import { List, ListItemButton } from '@mui/material';
import { managePaletteColor } from '../../themes/manage.theme-provider';
import { ManageIcon } from '../icons';
import { MenuAccordion, MenuAccordionProps } from './menu.accordion';

export type ManageMenuAccordionProps = Omit<
  MenuAccordionProps,
  'title' | 'icon' | 'children' | 'AccordionSummaryProps'
>;

export function ManageMenuAccordion(props: ManageMenuAccordionProps) {
  return (
    <MenuAccordion
      title="Manage"
      icon={<ManageIcon />}
      AccordionSummaryProps={{
        sx: {
          bgcolor: managePaletteColor.main,
          color: managePaletteColor.contrastText,
        },
      }}
      {...props}>
      <List>
        <ListItemButton component="a" href="https://next.splashmetrics.ai/manage/splashes">
          Splash
        </ListItemButton>
        <ListItemButton component="a" href="https://next.splashmetrics.ai/manage/metrics">
          Metrics
        </ListItemButton>
      </List>
    </MenuAccordion>
  );
}
